const dayjs = require('dayjs')
const isBetween = require('dayjs/plugin/isBetween')

dayjs.extend(isBetween)

export const hasOfferPreview = (
  market,
  previewCountMarketNoGlobal,
  previewCountGlobal,
  previewCountBmv
) => {
  let previewCount = 0
  if (
    market?.marketId == 1 ||
    typeof market?.marketId == 'undefined' ||
    !market?.marketId
  ) {
    previewCount = previewCountGlobal
  } else {
    previewCount = previewCountGlobal + previewCountMarketNoGlobal
  }

  if (market?.marketType == 2 && previewCountBmv > 0) return true

  if (previewCount > 0) return true
  return false
}
